import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getCampaingsFranchise, getUserInfo } from '../../actions/userActions';
import FranchiseeCampaing from '../../containers/Profile/FranchiseCampaing/FranchiseeCampaing';

const CampaignsList = ({match}) => {
    const dispatch = useDispatch();
    const { userProfileInfo,franchiseCampaigns } = useSelector(state => state.userInfo)
  

    useEffect(() => {
      
   
      if(userProfileInfo._id){
        if (userProfileInfo.franchiseID) {
          if (userProfileInfo.franchiseID.state ===2) {
           dispatch(getCampaingsFranchise(userProfileInfo.franchiseID._id))
          }
        }
     
      //  dispatch()
      } 
      return () => {
       
      }
    }, [userProfileInfo])
    
    
  return (
    <FranchiseeCampaing campaings={franchiseCampaigns}/>
  )
}

export default CampaignsList